import { DeviceKassaProps } from '@/interfaces/models/device';
import DeviceKassa from '@/models/deviceKassa';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat((poses: DeviceKassaProps[]) =>
      (poses || []).map((pos: DeviceKassaProps) => new DeviceKassa(pos)));
  }
};
